import type {ProductBox} from './ProductBox';
import {proxy} from 'valtio';
import {watch} from 'valtio/utils';
import type {DeepReadonly} from '@/lib/typings/readonly';
import {staticIpWidget, type StaticProductWidget} from '../StaticIpStore';
import {getAnalytics} from '@/hooks/useAnalytics';

export type StaticIpBox = ProductBox<StaticProductWidget>;

// if add any new field, add the new field to the below reset function also
export const staticIp = proxy<StaticIpBox>({
  _product: undefined,

  get selected() {
    return this._product;
  },

  get productId() {
    return this.selected?.productId;
  },

  get price() {
    return this.selected?.productCost?.units || 0;
  },

  get name() {
    return this.selected?.productName || '';
  },

  get isActualProduct() {
    return this.selected?.isActualProduct;
  },
});

export const resetStaticIp = () => {
  staticIp._product = undefined;
};

export const setStaticIp = (product: DeepReadonly<StaticProductWidget>) => {
  const analytics = getAnalytics();
  analytics.trackCardSelection(
    'static_ip_step',
    staticIp.productId || '',
    product.productId || '',
  );
  staticIp._product = product as StaticProductWidget;
};

// TODO subscribe would be preferred here, but it caused build errors around initialization.
watch(get => {
  get(staticIpWidget);
  if (staticIp._product) {
    return;
  }

  const defaultSelection = staticIpWidget.products.find(
    (x: StaticProductWidget) => x.isDefaultSelection,
  );

  const product = defaultSelection ?? staticIpWidget.products[0];
  if (!product) {
    return;
  }

  staticIp._product = product;
});
